const Tools = require('../../deploynaut/js/tools.jsx');
const Letmein = require('./Letmein.jsx');
const EnvironmentOverview = require('./EnvironmentOverview.jsx');
const EditStackForm = require('./EditStackForm.jsx');

Tools.install(EnvironmentOverview, 'EnvironmentOverview');
Tools.install(Letmein, 'Letmein');

$('body').on('click', '#StackEditFormTrigger', function(e) {
	e.preventDefault();

	var el = document.getElementById('EditStackFormModal');
	if (!el) {
		el = document.createElement('div');
		el.id = 'EditStackFormModal';
		document.body.appendChild(el);
	}

	var icon = $(this).children().first('i.fa');
	icon.addClass('fa-spinner fa-spin');
	$.ajax({
		url: $(this).attr('data-edit-form-url'),
		cache: false,
		type: 'GET',
		success: function(data) {
			$('#EditStackFormModal').html(data);
			Tools.install(EditStackForm, 'EditStackForm');
			icon.removeClass('fa-spinner fa-spin');
		},
		error: function() {
			icon.removeClass('fa-spinner fa-spin');
		}
	});
});
